import { Injectable } from '@angular/core';
import { ToastService } from 'src/app/_commonComponents/toastComponent/toast-service';
@Injectable({
  providedIn: 'root'
})
export class CommonUtilityService {

  constructor(private toastService: ToastService) { }

  possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  setModulePermission(moduleList: any, moduleType: any) {
    let permission: any = moduleList
    let modulePermission: any = {
      is_delete: false,
      is_write: false,
      is_update: false,
      is_view: false,
      is_critical: false
    }

    permission = permission.filter((item: any) => item.moduleName === moduleType)

    permission.forEach((item: any) => {
      if (!modulePermission.is_delete) {
        modulePermission.is_delete = item.is_delete
      }
      if (!modulePermission.is_update) {
        modulePermission.is_update = item.is_update
      }
      if (!modulePermission.is_view) {
        modulePermission.is_view = item.is_view
      }
      if (!modulePermission.is_write) {
        modulePermission.is_write = item.is_write
      }
      if (!modulePermission.is_critical) {
        modulePermission.is_critical = item.is_critical
      }
    })

    return modulePermission
  }

  validNumber(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  mobileValidation(data: any) {
    let text = data.toString()
    if (text.length !== 10) {
      return false
    }
    return true
  }
  emailValidation(input: any) {

    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (input.match(validRegex)) {

      return true;

    } else {

      return false;

    }
  }

  convertTimeToIST(date: any) {
    return new Date(date.getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000).toISOString()
  }

  generateCode(length: any) {
    let text = "";

    for (let i = 0; i < length; i++) {
      text += this.possible.charAt(Math.floor(Math.random() * this.possible.length));
    }
    return text.toUpperCase();
  }

  showSuccess(message: any) {
    this.toastService.show(message, { classname: 'bg-success text-center text-white', delay: 2000 });
  }

  showDanger(message: any) {
    this.toastService.show(message, { classname: 'bg-danger text-center text-white', delay: 2000 });
  }

  showInfo(message: any){
    this.toastService.show(message, { classname: 'bg-info text-center text-white', delay: 2000 });
  }

  inputValidation(data: any) {
    data = data || ''
    let text = data.toString()

    if (!text.length) {
      return false
    }
    return true
  }
}